import { useEffect, useMemo, useState } from "react";
import closeicon from "../img/close.svg";
import hinticon from "../img/lightbulb.svg";

import { translate } from '../functions/translationHelper';

function ModalHints({ open, onClose, hints, lang }) {
  // normalize hints to a clean array of strings
  const hintList = useMemo(() => {
    if (!hints) return [];
    if (Array.isArray(hints)) return hints.filter(Boolean).map(String);
    // in case backend accidentally sends as JSON string
    try {
      const parsed = JSON.parse(hints);
      return Array.isArray(parsed) ? parsed.filter(Boolean).map(String) : [];
    } catch {
      return [];
    }
  }, [hints]);

  // how many hints are revealed (0 => none revealed)
  const [revealedCount, setRevealedCount] = useState(0);

  // reset reveal progression when opening or when hints change
  useEffect(() => {
    if (open) setRevealedCount(0);
  }, [open, hintList.length]);

  // close on ESC
  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  const canShowMore = revealedCount < hintList.length;

  const revealNext = () => {
    setRevealedCount((prev) => Math.min(prev + 1, hintList.length));
  };


  return (
    <div className={`modalhints ${open ? null : "modalhintsclosed"}`}>
      <div className="modalhintsbackground" onClick={onClose} />

      <div
        className="modalhintsinner"
        role="dialog"
        aria-modal="true"
        aria-label="Hints"
      >
        <img src={hinticon} className="modalhinticon" />
        <img
          src={closeicon}
          className="modalhintscloseicon"
          alt="Close"
          onClick={onClose}
        />

  

        <div className="modalHintsList">
          {hintList.length === 0 ? (
            <div className="modalHintsEmpty">No hints available.</div>
          ) : (
            hintList.map((text, idx) => {
              const isRevealed = idx < revealedCount;
              const isNextToReveal = idx === revealedCount;

              return (
                <div key={idx} className="hintitem">
                  <div className={`hintitemtext ${isRevealed ? "" : "hintitemtext-blurred"}`}>
                    {text}
                  </div>
                  

                  {isNextToReveal && (
                    <div className="hintlistitembutton button-secondary" onClick={revealNext}>
                      {translate("showhint", lang)}
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>

      </div>
    </div>
  );
}

export default ModalHints;
